<template>
  <div v-if="languages && languages.length" class="candidate-languages">
    <p class="candidate-languages-title">{{ $t("ETAB.PAGES.EXTRA.@LANGUAGES_TITLE") }}</p>
    <div class="candidate-languages-card">
      <div v-for="(langue, index) in languages" :key="index">
        <div :class="langue.is_verified ? `candidate-languages-list-certified` : `candidate-languages-list`">
          <div class="candidate-languages-name">{{ langue.name }}</div>
          <div class="candidate-languages-level">{{ langue.level }}</div>
          <ExtraCertificationBadge
            v-if="langue.is_verified"
            :label="$t('ETAB.PAGES.EXTRA.@VERIFIED')"
            :top="1"
            :right="-30"
            color="#ff2c55"
            class="extra-certification-badge"
          >
            <template #picture>
              <img :src="extracadabraPicture" alt="verified" class="picture" />
            </template>
          </ExtraCertificationBadge>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, ref } from "vue";
  import ExtraCertificationBadge from "@core/components/design-system/ExtraCertificationBadge.component.vue";
  const props = defineProps({
    languages: {
      type: Array,
      default: () => [],
    },
  });
  const logo = require("@etab/assets/img/extra_logo_white.png");
  const extracadabraPicture = ref(logo);
</script>

<style lang="scss" scoped>
  .candidate-languages {
    margin-top: 20px;
    &-title {
      font-size: 22px;
      font-weight: 600;
      margin-left: 5px;
      margin-bottom: 5px;
    }

    &-card {
      position: relative;
      background-color: white;
      border-radius: 12px;
      padding: 15px 20px 15px 0px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
      max-width: 740px;
    }

    &-list {
      display: flex;
      align-items: center;
      padding: 15px 10px;
      position: relative;

      &:not(:last-child) {
        border-bottom: 1px solid #f0f0f0;
      }
    }
    &-list-certified {
      display: flex;
      align-items: center;
      padding: 5px 10px;
      position: relative;
      background-color: #ffeaee;
      &:not(:last-child) {
        border-bottom: 1px solid #f0f0f0;
      }
    }
    &-name {
      width: 170px;
      font-weight: 500;
      @media (max-width: $breakpoint-sm) {
        width: 120px;
      }
    }

    &-level {
      color: #888;
      flex-grow: 1;
    }
    .extra-certification-badge {
      .picture {
        width: 20px;
        height: 20px;
      }
    }
  }
</style>
